export const companyBenefitStatusIds = {
  PENDING: 1,
  ACTIVE: 2,
};
